import React from "react";
import currency from "currency.js";
import i18next from "i18next";

const ENGLISH = "en";

const formatMoney = (amount: number, locale?: string): string => {
    const selectedLocale = locale ? locale : i18next.language;
    // @ts-ignore
    const formattedAmount = (currency[selectedLocale] || currency["_default"])(parseFloat(String(amount))).format();

    if (selectedLocale.startsWith(ENGLISH)) {
        return `$${formattedAmount}`;
    }

    return `${formattedAmount} $`;
};

interface MoneyDisplayProps {
    amount: number;
    accountingFormat?: boolean;
    withCurrencySymbol?: boolean;
}

interface MoneyDisplayContext {
    intl: {
        locale: string;
    };
}

const MoneyDisplay: React.FC<MoneyDisplayProps> = (
    { amount, accountingFormat = true, withCurrencySymbol = true },
    context: MoneyDisplayContext
) => {
    const option: Intl.NumberFormatOptions = {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    };

    if (withCurrencySymbol) {
        option.style = "currency";
        option.currency = "CAD";
    }

    const lang = i18next.language;
    const langCountry = `${lang}-CA`;
    let formatDisplay = new Intl.NumberFormat(langCountry, option).format(amount);

    if (accountingFormat && amount < 0) {
        const numberFormattedToLang = new Intl.NumberFormat(langCountry, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(Math.abs(amount));

        formatDisplay = `(${numberFormattedToLang})`;

        if (withCurrencySymbol) {
            formatDisplay = lang.startsWith(ENGLISH) ? `$${formatDisplay}` : `${formatDisplay}$`;
        }
    }

    return <span className="money-amount">{formatDisplay}</span>;
};
export default MoneyDisplay;
export { formatMoney };
